var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-master"}},[_c('div',{staticClass:"ml-0 bgImage",style:(_vm.currentPage && _vm.signupImage),attrs:{"id":"page"}},[_c('div',{attrs:{"id":"user-pages"}},[_c('div',{staticClass:"container"},[_c('main',[_c('router-view')],1)])]),_c('MasterFooter')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }